import { render, staticRenderFns } from "./SpecView.vue?vue&type=template&id=3e864e05&"
import script from "./SpecView.vue?vue&type=script&lang=js&"
export * from "./SpecView.vue?vue&type=script&lang=js&"
import style0 from "./SpecView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports